import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Topbar from './component/Topbar';
import Footer from './component/Footer';
import './App.css';
import './assets/css/style.css';
import './assets/css/common.css';
import './assets/css/chat.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ScrollToTop from './assets/ScrollToTop';
import BasicInfo from './pages/Registration/BasicInfo';
import ProfileInfo from './pages/Registration/ProfileInfo';
import PartnerPreferences from './pages/Registration/PartnerPreferences';
import PersonalityInterests from './pages/Registration/PersonalityInterests';
import PartnerCards from './pages/PartnerCards';
import ViewProfile from './pages/ViewProfile';
import Chats from './pages/Chats';
import Notification from './pages/Notification';
import AdvancedSearch from './pages/AdvancedSearch';
import ReligionDetail from './pages/Registration/ReligionDetail';
import ProfileImages from './pages/Registration/ProfileImages';
import Help from './pages/General/Help';
import AboutUser from './pages/Registration/AboutUser';
import PrivacyPolicy from './pages/General/PrivacyPolicy';
import Terms from './pages/General/Terms';
import ChatWindow from './pages/ChatWindow';
import ContactUs from './pages/ContactUs';
import Profile from './pages/Profile';
import NewFaqs from './pages/General/NewFaqs';
import AboutUs from './pages/General/AboutUs';

function AppContent() {
  const location = useLocation();

  // Hide footer only on Chats page
  // const hideFooterRoutes = ['/chats', '/profile/view/'];
  // const shouldShowFooter = !hideFooterRoutes.includes(location.pathname);

    // Hide TOPBAR only on Chats page
  const hideTopbar =
    location.pathname === "/chats"||
  location.pathname.startsWith("/chat/");



  


  const hideFooter =
  location.pathname === "/chats" ||
  location.pathname === "/about-user" ||
  location.pathname === "/partner-preference" ||
  location.pathname === "/religion-detail" ||
  location.pathname === "/profile-info" ||
  location.pathname === "/my-profile" ||
  location.pathname === "/profile-images" ||
  location.pathname === "/my-soulsathi" ||
  location.pathname === "/search" ||
  location.pathname.startsWith("/profile/view/") || 
   location.pathname.startsWith("/chat/");

const shouldShowFooter = !hideFooter;


  return (
    <>
      <ScrollToTop />
       {/* SHOW TOPBAR ONLY IF NOT HIDDEN */}
      {!hideTopbar && <Topbar />}
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/basic-info" element={<BasicInfo />} />
        <Route path="/profile-info" element={<ProfileInfo />} />
        <Route path="/religion-detail" element={<ReligionDetail />} />
        <Route path="/profile-images" element={<ProfileImages />} />
        <Route path="/about-user" element={<AboutUser />} />

        <Route path="/help" element={<Help />} />

        <Route path="/partner-preference" element={<PartnerPreferences />} />
        <Route path="/personality-interests" element={<PersonalityInterests />} />
        <Route path="/my-soulsathi" element={<PartnerCards />} />
        <Route path="/profile/view/:uid" element={<ViewProfile />} />
        <Route path="/chats" element={<Chats />} />


        <Route path="/chat/:uid" element={<ChatWindow />} />
        <Route path="/notifications" element={<Notification />} />
        <Route path="/search" element={<AdvancedSearch />} />


        <Route path="/contact" element={<ContactUs />} />
        <Route path="/my-profile" element={<Profile />} />
 

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<Terms />} />
        <Route path="/faq" element={<NewFaqs />} />
        <Route path="/about" element={<AboutUs />} />
      </Routes>
      {shouldShowFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <GoogleOAuthProvider clientId="899286520109-598upt57ult4tqbrgjl5hnmhd5hqk755.apps.googleusercontent.com">
      <Router>
        <AppContent />
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
